import { Injectable, inject } from '@angular/core';
import {
  IConfigDeseada,
  IListado,
  IQueryParam,
  IResumenAplicacionPerfil,
} from 'modelos/src';
import { HttpClientService } from '../http.service';
import { HelperService } from '../helper.service';

@Injectable({ providedIn: 'root' })
export class ConfigsDeseadasService {
  private http = inject(HttpClientService);

  public getFiltered(
    queryParams?: IQueryParam,
  ): Promise<IListado<IConfigDeseada>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get('/configdeseadas', { params });
  }

  public getById(id: string): Promise<IConfigDeseada> {
    return this.http.get(`/configdeseadas/${id}`);
  }

  /**
   * El avance de cada acción que mandó perfiles (Seguimiento de luminarias): el
   * backend agrupa las configuraciones deseadas por la marca de la acción. Sin
   * `desde`, los últimos 30 días.
   *
   * `includeChildren` suma las de los clientes hijos (si el permiso tiene
   * habilitado verlos).
   */
  public aplicaciones(params?: {
    desde?: string;
    limit?: number;
    includeChildren?: boolean;
  }): Promise<(IResumenAplicacionPerfil & { id: string })[]> {
    const p: Record<string, string> = {};
    if (params?.desde) p['desde'] = params.desde;
    if (params?.limit) p['limit'] = String(params.limit);
    if (params?.includeChildren) p['includeChildren'] = 'true';
    return this.http.get('/configdeseadas/aplicaciones', { params: p });
  }
}
